// import axios from "axios";

import apiInstance from '../services';
import ApiConstants from '../services/apiConstants';
import registerApiInstance from '../services/registerApiInstance';
import apiInstanceJavaService from '../services/registerApiIntanceJava';

// export const userRegister = async (data: any) => {
//   try {
//     return Promise.resolve(
//       await apiInstance.post(ApiConstants.USER_REGISTER, data)
//     );
//   } catch (error) {
//     return Promise.reject(error);
//   }
// };

export const userRegister = async (data: any) => {
  
  try {
    return Promise.resolve(
      await apiInstanceJavaService.post(ApiConstants.USER_REGISTER_JAVA, data)
    );
  } catch (error) {
    return Promise.reject(error);
  }
};

export const userLogin = async (data: any) => {
  try {
    return Promise.resolve(
      await apiInstance.post(ApiConstants.USER_REGISTER, data)
    );
  } catch (error) {
    return Promise.reject(error);
  }
};

export const generateLink = async (data: any) => {
  try {
    return Promise.resolve(
      await registerApiInstance.post(ApiConstants.GENERATE_URL_JAVA, data)
    );
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getCustomerFormData = async (data: any) => {
  try {
    return Promise.resolve(
      await apiInstance.get(`${ApiConstants.GET_FORM_DATA_JAVA}${data}`)
    );
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getValidRegistrationNumber = async (data: any) => {
  try {
    return Promise.resolve(
      await registerApiInstance.get(
        `${ApiConstants.GET_VALID_REGISTRATION_NUMBER}${data}`
      )
    );
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getPreferedPartnerDataService = async (data: any) => {
  //   const dataSaurce = [
  //     {
  //         "id": 4,
  //         "label": "Example Partner Co.",
  //         "value": null
  //     },
  //     {
  //         "id": 5,
  //         "label": "Example Partner Co.",
  //         "value": null
  //     },
  //     {
  //         "id": 6,
  //         "label": "Example Partner Co.",
  //         "value": null
  //     },
  //     {
  //         "id": 7,
  //         "label": "Example Partner Co.",
  //         "value": "active"
  //     },
  //     {
  //         "id": 8,
  //         "label": "Example Partner Co.",
  //         "value": null
  //     },
  //     {
  //         "id": 9,
  //         "label": "Example Partner Co.",
  //         "value": null
  //     },
  //     {
  //         "id": 10,
  //         "label": "Example Partner Co.",
  //         "value": null
  //     }
  // ]
  try {
    return Promise.resolve(await registerApiInstance.get(`/company/public/partner`));
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getValidApplicantEmail = async (data: any) => {
  try {
    return Promise.resolve(
      await apiInstanceJavaService.get(`${ApiConstants.GET_VALID_APPLICANT_EMAIL}email=${data}`)
    );
  } catch (error) {
    return Promise.reject(error);
  }
};

//get tenent account data
export const getTenantAccountTypesService = async () => {
  try {
    return Promise.resolve(await registerApiInstance.get(ApiConstants.TENANT_ACCOUNT_TYPES));
  } catch (error) {
    return Promise.reject(error);
  }
};

